var API_URL = {
    login: '/token',
    checkLogin: '/check-login',
    loginOtp: '/check-login-otp',
    loginGoogle2fa: '/check-login-2fa',

    user: {
        create: '/users',
        sendCampaign: '/users/send-campaign/__id__',
        update: '/users/__id__',
        findById: '/users/__id__',
        findMany: '/users',
        findOrderList: '/users/order-list/__id__',
        findUtmList: '/users/users/utm-list',
        findPartnerList: '/partners/user-partner-list',
        findManyGuest: '/users/guest',
        findManyCountry: '/users/country',
        findUserDetail: '/users/__id__/details',
        findQuizPayout: 'users/__id__/quiz-payouts',
        updateQuizPayout: 'users/__id__/quiz-payouts/__payout-id__',
        delete: '/users/__id__',
        deleteSubscriber: '/users/__id__/delete-subscriber',
        findBySchool: 'users/__id__/user-school',
        createUserBySchool: 'users/school/__id__',
        updateGoogle2fa: 'users/__id__/update-google-2fa',
        findGoogle2faData: 'users/__id__/get-google-2fa',
        findByPartnerAffiliateCode: 'users/__code__/get-partner-affiliate-code',
        findUserByAffiliateCode: 'users/__code__/get-affiliate-code',
        addNumberAiQusetion: 'users/__id__/add-number-ai-qusetion',
        findInactiveUsers: '/users/users/inactive-users',
        adminDeleteUser: '/users/__id__/unregister'
    },
    quiz: {
        create: '/quiz',
        update: '/quiz/__id__',
        findById: '/quiz/__id__',
        findMany: '/quiz',
        createQuestion: '/quiz/__id__/create',
        delete: '/quiz/__id__',
        deleteMany: '/quiz/many/__id__',
        importQuestion: '/quiz/__id__/import-question',
        setUserQuizToFrontpage: '/quiz/set-quiz-to-frontpage',
        updateUserQuizApproveStatus: '/quiz/__id__/update-user-quiz-approve-status',
        checkCloneQuestion: '/quiz/check-clone-question',
        cloneQuestion: '/quiz/clone-question',
        approveUserQuizToFrontpage: '/quiz/approve-quiz-to-frontpage',
        approve: '/quiz/approve/__id__',
        reject: '/quiz/reject/__id__',
        setIsSponsorQuiz: '/quiz/__id__/set-sponsor-quiz',
        updateSponsorSetting: '/quiz/__id__/sponsor-quiz',
        getSponsorQuizTracker: '/quiz/__id__/sponsor-quiz/trackers',
        getSponsorQuizRankList: '/quiz/__id__/sponsor-quiz/rank',
        exportSponsorQuizRankXlsx: '/quiz/__id__/sponsor-quiz/export',
        deleteSponsorQuizRow: '/quiz/__id__/sponsor-quiz/delete/__rowId__',
        getEmbed: '/quiz/__id__/embed',
        getSchoolSubjectById: '/quiz/__id__/get-school-subject',
        updatePinQuiz: '/quiz/__id__/update-pin-quiz',
        findManyCountry: '/quiz/country',
    },
    userQuiz: {
        findMany: '/userQuiz'
    },
    question: {
        create: '/question',
        update: '/question/__id__',
        findById: '/question/__id__',
        findMany: '/question',
        delete: '/question/__id__',
        deleteMany: '/question/many/__id__',
        import: '/question/import',
        updateTags: '/question/many/update-tags',
        findManyMeta: '/question/meta-question',
    },
    tag: {
        create: '/tag',
        update: '/tag/__id__',
        findAll: '/tag/all',
        findMany: '/tag',
        delete: '/tag/__id__',
        deleteMany: '/tag/many/__id__'
    },
    resultMessage: {
        create: '/result-message',
        update: '/result-message/__id__',
        findMany: '/result-message',
        delete: '/result-message/__id__',
        deleteMany: '/result-message/many/__id__'
    },
    setting: {
        create: '/setting/create',
        getSetting: '/setting',
        update: '/setting/__id__',
        flushCache: '/flush-cache',
        sendNewsletter: '/setting/send-newsletter'
    },
    language: {
        getLanguage: '/language',
        putLanguage: '/language',
        putLanguageTranslation: '/language/translation-result-messages',
        getLang: '/language/lang',
    },
    upload: '/upload-image',
    uploadVideo: '/upload-video',
    order: {
        list: '/orders/list',
        suspendPlayerOrder: '/orders/suspend/buy-player',
        addCreditUser: '/orders/add-credit-user',
        listPending: '/orders/list-pending',
        checkStatusOrder: '/orders/check-status-order',
        deleteOrderPending: '/orders/delete-order-pending',
        removeCreditUser: '/orders/remove-credit-user'
    },
    plan: {
        unsubscribe: '/plans/unsubscribe',
        suspend: '/plans/suspend'
    },
    dashboard: {
        members: '/dashboard/members',
        userQuizCreated: '/dashboard/user-quiz-created',
        popularAdminQuiz: '/dashboard/popular-admin-quiz',
        popularUserQuiz: '/dashboard/popular-user-quiz',
        subscriptions: '/dashboard/subscriptions',
        hour24: '/dashboard/hour24',
        playAlone: '/dashboard/play-alone',
        playTogether: '/dashboard/play-together',
        firebaseMonitorConnection: '/dashboard/firebase-monitor',
    },
    songQuestion: {
        cacheSpotifySong: '/song-question/cache'
    },
    pages: {
        create: '/pages/create',
        update: '/pages/__id__',
        findById: '/pages/__id__',
        findMany: '/pages',
        delete: '/pages/__id__',
        updatePageOrder: '/pages',
        getListPageCategory: '/page-categories',
        createPageCategory: '/page-categories',
        deletePageCategory: '/page-categories/__id__',
        updatePageCategory: '/page-categories/__id__',
    },
    blogs: {
        findMany: '/blogs',
    },
    logs: {
        findMany: '/logs',
        countAllType: '/logs/count-all-type'
    },
    coupons: {
        findMany: '/coupon',
    },
    campaigns: {
        findMany: '/campaign',
        findById: '/campaign/__id__',
        createCampaign: '/campaign/create-campaign',
        updateCampaign: '/campaign/update-campaign/__id__',
        updateCampaignStatus: '/campaign/update-campaign-status/__id__',
        updateCampaignStatusAll: '/campaign/update-campaign-status-all',
        deleteCampaign: '/campaign/delete-campaign/__id__',
    },
    school: {
        findMany: '/school',
        create: '/school/create',
        update: '/school/__id__',
        findBySchool: '/school/__id__',
        delete: '/school/__id__',
        getSubjects: '/school/subject-list/__id__',
        getAvailableSubjects: '/school/available-subjects',
    },

    googleApi: {
        getVisitByDate: '/dashboard/google-api-visit-by-date',
        getVisitCompare: '/dashboard/google-api-visit-by-date-compare',
        getTopQuizes: '/dashboard/google-api-top-quizes',
        getConversion: '/dashboard/google-api-conversion',
        getQuizConversion: '/dashboard/google-api-conversion-question',
    },

    schoolQuiz: {
        findMany: '/school-quiz/__id__/get-school-list'
    },

    subjectList: {
        findMany: '/subject-list',
        findManyByList: '/subject-list/list',
        create: '/subject-list',
        update: '/subject-list/__id__',
        delete: '/subject-list/__id__',
        bulkAssignRevokeToSchool: '/subject-list/bulk-assign-revoke-to-school',
    },

    schoolQuizCollection: {
        findMany: '/school-quiz-collection',
        create: '/school-quiz-collection',
        update: '/school-quiz-collection/__id__',
        delete: '/school-quiz-collection/__id__',
        getQuizCollectionById: '/school-quiz-collection/__id__/get-quiz-collection',
        getQuizCollectionByIdList: '/school-quiz-collection/__id__/quiz-collection-list',
        deleteQuizList: '/school-quiz-collection/__id__/delete-quiz-list',
        findManyByQuizList: '/school-quiz-collection/quiz-list-all',
        bulkAssignRevokeToSchool: '/school-quiz-collection/bulk-assign-revoke-to-school',
    },

    schoolDistrict: {
        findMany: '/school-district',
        findById: '/school-district/__id__',
        findManyByDistrict: '/school-district/__id__/school-list',
        create: '/school-district/create',
        update: '/school-district/__id__',
        delete: '/school-district/__id__'
    },

    requestSchoolToPlus: {
        findMany: '/request-to-plus',
        update: '/request-to-plus/__id__',
        delete: '/request-to-plus/__id__',
        getTotalRequestToPlus: '/request-to-plus/total-request-to-plus',
    },

    teacherRequest: {
        findMany: '/teacher-request',
        update: '/teacher-request/__id__/update-status',
        assignUserToSchool: '/school/__id__/add-to-school',
        getTotalTeacherRequest: '/teacher-request/total-pending-request',
    },

    //search Image from External
    fetchImageSearch: "/images/search",
    generateImageSearch: "/images/keep",
    searchMusic: '/music/search',
    fontList: '/font',

    chatGPT: {
        generateQuizDescription: "/quiz/generate-description",
        generateAiImage: "/generate-image",
        generateQuizSeoKeyword: "/quiz/generate-quiz-keywords",
        generateTranslate: "/translate",
        generateAiBackground: "/generate-background"
    },

    frontPage: {
        putFrontPage: '/front-page-widget',
        getFrontPage: '/front-page-widget',
        putSchoolPage: '/school-front-page-widget',
        getSchoolPage: '/school-front-page-widget',
    },

    partner: {
        findMany: '/partners',
    },

    payout: {
        findByPoint: '/payout',
        createPayout: '/payout/create-payout',
        getPayoutPending: '/payout/get-payout-pending',
        getPendingCount: '/payout/pending-count',
    }
}

export default API_URL
